import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { EMPTY_ARRAY_LENGTH } from '../../../../../aumico-lib-core-fe/src/lib';

@Component({
    selector: 'ham-inline-table-cell-edit',
    templateUrl: './ham-inline-table-cell-edit.component.html',
    styleUrls: ['./ham-inline-table-cell-edit.component.scss'],
})
export class HamInlineTableCellEditComponent implements OnInit, OnChanges {
    @Input() isEditing = false;
    public textForm = new FormControl<string>('');
    @Input() value: string;
    @ViewChild('input') input: ElementRef<HTMLInputElement>;
    @Output() save = new EventEmitter<string>();

    public editValue: string | undefined;

    ngOnInit(): void {
        this.textForm.setValue(this.value);
    }

    ngOnChanges(changes): void {
        if (changes['value'] && this.value != null) {
            this.textForm.setValue(this.value);
        }
    }

    preventDefault(event: KeyboardEvent | MouseEvent): void {
        event.stopImmediatePropagation();
        event.stopPropagation();
    }

    toggleEdit(): void {
        if (!this.isEditing) {
            this.isEditing = true;
            this.setFocusOnInput();
        } else if (this.textForm.value != null && this.textForm.value?.trim().length > EMPTY_ARRAY_LENGTH) {
            this.value = this.textForm.value;
            this.save.emit(this.value);
            this.isEditing = false;
        }
    }

    private setFocusOnInput(): void {
        const immediate = 0;
        setTimeout(() => {
            this.input.nativeElement.focus();
        }, immediate);
    }
}
